import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Dialog,
  DialogActions,
  Grid
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import globalStyle from "../../globalStyle";
import { changePasswordValidation } from "../../utils/Validation";
import GlobalButton from "../CustomButton";
import DialogHeader from "../Dialog/Header";
import Label from "../Label";
import TextInput from "../TextInputs";
import DialogBody from "./Body";
import DialogActionButtons from "./Footer";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogActions-root": {
    padding: "25px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "25px  8px",
    },
  },
}));

let paramsData = {};

const initialInputValues = {
  newPassword: "",
  reEnterPassword: "",
  oldPassword: "",
};

const initialShowPassword = {
  newPassword: false,
  reEnterPassword: false,
  oldPassword: false,
};

const ChangePasswordDialog = forwardRef(({ handleChangePassword }, ref) => {
  const { t } = useTranslation(["common"]);
  const [open, setOpen] = useState(false);
  const [inputError, setInputError] = useState({});
  const [inputValues, setInputValues] = useState(initialInputValues);
  const [showPassword, setShowPassword] = useState(initialShowPassword);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog(params) {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setInputValues(initialInputValues);
    setInputError({});
    setShowPassword(initialShowPassword);
  };

  const handleChangeInputValues = (event) => {
    const { name, value } = event.target;
    setInputValues((prev) => ({ ...prev, [name]: value }));
    setInputError((prevErr) => ({ ...prevErr, [name]: "" }));
  };

  const toggleShowPassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >

      <DialogHeader
        title={t("changePassword")}
        secondaryHeading={t("changePasswordDescription")}
        onClose={handleClose}
        icon={<LockIcon />}
      />
      <DialogBody>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label
              labelText={t("oldPassword")}
              required
              htmlFor={"old-password"}
            />
            <TextInput
              styleProps={globalStyle.textField}
              id={"old-password"}
              required
              type={!showPassword.oldPassword ? "text" : "password"}
              placeholder={t("enterOldPassword")}
              name={"oldPassword"}
              value={inputValues.oldPassword}
              onChange={handleChangeInputValues}
              inputError={Boolean(inputError.oldPassword)}
              helperText={t(inputError.oldPassword)}
              InputEndIcon={
                // Pass the InputEndIcon prop
                showPassword.oldPassword ? (
                  <VisibilityOff
                    sx={{ cursor: "pointer" }}
                    onClick={() => toggleShowPassword("oldPassword")}
                  />
                ) : (
                  <Visibility
                    sx={{ cursor: "pointer" }}
                    onClick={() => toggleShowPassword("oldPassword")}
                  />
                )
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Label
              labelText={t("newPassword")}
              required
              htmlFor={"new-password"}
            />
            <TextInput
              styleProps={globalStyle.textField}
              id={"new-password"}
              required

              type={!showPassword.newPassword ? "text" : "password"}
              placeholder={t("enterNewPassword")}
              name={"newPassword"}
              value={inputValues.newPassword}
              onChange={handleChangeInputValues}
              inputError={Boolean(inputError.newPassword)}
              helperText={t(inputError.newPassword)}
              InputEndIcon={
                // Pass the InputEndIcon prop
                showPassword.newPassword ? (
                  <VisibilityOff
                    sx={{ cursor: "pointer" }}
                    onClick={() => toggleShowPassword("newPassword")}
                  />
                ) : (
                  <Visibility
                    sx={{ cursor: "pointer" }}
                    onClick={() => toggleShowPassword("newPassword")}
                  />
                )
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Label
              labelText={t("reEnterPassword")}
              required
              htmlFor={"re-enter-password"}
            />
            <TextInput
              styleProps={globalStyle.textField}
              id={"re-enter-password"}
              required
              type={"password"}
              placeholder={t("enterReEnterPassword")}
              name={"reEnterPassword"}
              value={inputValues.reEnterPassword}
              onChange={handleChangeInputValues}
              inputError={Boolean(inputError.reEnterPassword)}
              helperText={t(inputError.reEnterPassword)}
            />
          </Grid>
        </Grid>
      </DialogBody>
      <DialogActionButtons

        onConfirm={() => {
          const validate = changePasswordValidation(
            inputValues,
            setInputError
          );
          if (!validate) {
            handleChangePassword(inputValues);
          }
        }}
        onCancel={handleClose}
        confirmText={"save"}
        cancelText={"cancel"}
        showCancelButton={true}
      />

    </BootstrapDialog>
  );
});

export default ChangePasswordDialog;
